<template>
  <div :class="['vc-sketch', disableAlpha ? 'vc-sketch__disable-alpha' : '']">
    <div class="vc-sketch-saturation-wrap">
      <saturation
        v-model="colors"
        @change="childChange"
      ></saturation>
    </div>
    <div class="vc-sketch-controls">
      <div class="vc-sketch-sliders">
        <div class="vc-sketch-hue-wrap">
          <hue
            v-model="colors"
            @change="childChange"
          ></hue>
        </div>
        <div
          v-if="!disableAlpha"
          class="vc-sketch-alpha-wrap"
        >
          <alpha
            v-model="colors"
            @change="childChange"
          ></alpha>
        </div>
      </div>
      <div class="vc-sketch-color-wrap">
        <checkboard></checkboard>
      </div>
    </div>
    <div
      v-if="!disableFields"
      class="vc-sketch-field"
    >
      <div
        v-show="hasEyedropper"
        class="vc-sketch-eyedropper"
        @click="eyedropperStart"
      >
        <iconfont
          name="#icon21-1quseqi1"
          font-size="17px"
          color="#666666"
        ></iconfont>
      </div>
      <div class="vc-sketch-field-hex">
        <span class="vc-sketch-label">Hex:</span>
        <ed-in
          :value="`#${hex}`"
          @change="inputChange"
        ></ed-in>
      </div>
    </div>
    <div class="vc-sketch-presets">
      <div
        v-for="c in presetColors"
        :key="c"
        class="vc-sketch-presets-color"
        :class="c === 'none' && 'vc-preset-color-none'"
        :style="{ background: c }"
        @click="handlePreset(c)"
      ></div>
    </div>
  </div>
</template>
<script>
import { Saturation, ColorMixin, Hue, Checkboard, EditableInput } from 'vue-color';

const presetColors = [
  '#456BFF',
  '#9A6DD2',
  '#F9EAD5',
  '#9C4A48',
  '#FFFFFF',
  '#F9BACD',
  '#3AF858',
  '#FB4456',
  '#FF9AFF',
  '#FF7D5C',
  '#5AFFFF',
  '#A0CF92',
  '#3FAD64',
  '#456BAF'
];

export default {
  name: 'ColorPicker',
  components: {
    Saturation,
    Hue,
    Checkboard,
    'ed-in': EditableInput
  },
  mixins: [ColorMixin],
  props: {
    presetColors: {
      type: Array,
      default() {
        return presetColors;
      }
    },
    disableAlpha: {
      type: Boolean,
      default: true
    },
    disableFields: {
      type: Boolean,
      default: false
    },
    hasEyedropper: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    hex() {
      let hex;
      if (this.colors.a < 1) {
        hex = this.colors.hex8;
      } else {
        hex = this.colors.hex;
      }
      return hex.replace('#', '');
    }
  },
  methods: {
    handlePreset(c) {
      this.colorChange({
        hex: c,
        source: 'hex'
      });
      this.$emit('childChange');
    },
    childChange(data) {
      this.colorChange(data);
      this.$emit('childChange');
    },
    inputChange(data) {
      if (!data) {
        return;
      }
      if (data.hex) {
        this.isValidHex(data.hex) &&
          this.colorChange({
            hex: data.hex,
            source: 'hex'
          });
      } else if (data.r || data.g || data.b || data.a) {
        this.colorChange({
          r: data.r || this.colors.rgba.r,
          g: data.g || this.colors.rgba.g,
          b: data.b || this.colors.rgba.b,
          a: data.a || this.colors.rgba.a,
          source: 'rgba'
        });
      }
    },
    eyedropperStart() {
      this.$bus.emit('maskLayer', {
        show: true,
        type: 'eyedropper',
        msg: {
          selector: '.video-cropper .editor-ratio'
        },
        maskBg: 'rgba(0, 0, 0, 0)'
      });
    }
  }
};
</script>
<style lang="scss">
.vc-sketch {
  position: relative;
  width: 100%;
  box-sizing: initial;
}

.vc-sketch-saturation-wrap {
  width: 100%;
  height: 118px;
  padding-bottom: 38%;
  border-radius: 4px;
  position: relative;
  overflow: hidden;
}

.vc-sketch-controls {
  display: flex;
  align-items: center;
}

.vc-sketch-sliders {
  padding: 4px 0;
  flex: 1;
}

.vc-sketch-hue-wrap {
  position: relative;
  height: 10px;
  border-radius: 4px;
}

.vc-sketch-alpha-wrap {
  position: relative;
  height: 10px;
  margin-top: 4px;
  overflow: hidden;
}

.vc-sketch-color-wrap {
  display: none;
}
.vc-sketch-field {
  display: flex;
  justify-content: space-between;
  padding-top: 20px;
}

.vc-sketch-eyedropper {
  width: 30px;
  height: 30px;
  line-height: 38px;
  background: #f6f7fb;
  border-radius: 4px;
  cursor: pointer;
}

.vc-editable-input {
  background: #ffffff;
  border: 1px solid #e6e6e6;
  border-radius: 4px;
  overflow: hidden;
}

.vc-sketch-field .vc-input__input {
  width: 150px;
  height: 30px;
  line-height: 30px;
  padding: 0;
  text-align: center;
  border: none;
  font-size: 14px;
}

.vc-sketch-field .vc-input__label {
  display: none;
}
.vc-sketch-field .vc-input__desc {
  display: none;
}

.vc-sketch-field-hex {
  display: flex;
  align-items: center;

  .vc-sketch-label {
    width: 58px;
    font-size: 14px;
    margin-right: 5px;
  }
}

.vc-sketch-presets {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  padding-top: 20px;
}

.vc-sketch-presets-color {
  border-radius: 4px;
  overflow: hidden;
  position: relative;
  vertical-align: top;
  cursor: pointer;
  width: 32px;
  height: 32px;
  margin: 0 0 8px 6px;
  border: 1px solid #e6e6e6;

  &:nth-child(7n + 1) {
    margin-left: 0px;
  }
}

.vc-sketch-presets-color .vc-checkerboard {
  box-shadow: inset 0 0 0 1px rgba(0, 0, 0, 0.1);
  border-radius: 3px;
}
</style>
